import http from "../http"

/**
 * 用户登录  祥辰 token
 * @param param
 * @returns {*}
 */
export function xcUserLogin(param) {
  return http({
    url: '/api/v1/auth/login',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 * 获取设备状态
 * @param deviceAddr
 * @returns {*}
 */
export function deviceState(deviceAddr) {
  return http({
    url: '/api/v1/device/status?productId=' + deviceAddr,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 设备控制接口
 * @param param
 * @returns {*}
 */
export function orderOperate(param) {
  return http({
    url: '/api/v1/pbb/order',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 * 图像接口
 * @param deviceAddr
 * @param startTime
 * @param endTime
 * @returns {*}
 */
export function deviceImg(deviceAddr, startTime, endTime) {
  return http({
    url: '/api/v1/img/info?deviceID=' + deviceAddr + '&startTime=' + startTime + '&endTime=' + endTime,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 识别图像数据
 * @param imgId
 * @returns {*}
 */
export function imgData(imgId) {
  return http({
    url: '/api/v1/img/rec/info?imgID=' + imgId,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 *虫情测报灯运行状态1
 * @param deviceAddr
 * @returns {*}
 */
export function pestDeviceState(deviceAddr) {
  return http({
    url: '/api/v1/cbd/status/' + deviceAddr,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 虫情测报灯运行状态2
 * @param deviceAddr
 * @returns {*}
 */
export function pestCurrentState(deviceAddr) {
  return http({
    url: '/api/v1/cbd/currentStatus/' + deviceAddr,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 虫情测报灯接口控制
 * @param param
 * @returns {*}
 */
export function pestOrderOperate(param) {
  return http({
    url: '/api/v1/cbd/order',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 * 孢子接口控制
 * @param param
 * @returns {*}
 */
export function sporeOrderOperate(param) {
  return http({
    url: '/api/v1/bzq/order',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 * 查询杀虫灯数据
 * @param deviceAddr
 * @param startTime
 * @param endTime
 * @returns {*}
 */
export function lampData(deviceAddr, startTime, endTime) {
  return http({
    url: '/api/v1/scd/status?deviceID=' + deviceAddr + '&startTime=' + startTime + '&endTime=' + endTime,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 杀虫灯命令
 * @param param
 * @returns {*}
 */
export function lampOrderOperate(param) {
  return http({
    url: '/api/v1/scd/order',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

export function userLogin(param) {
  return http({
    url: '/api/v2.0/entrance/user/userLogin',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

export function spUserDevice() {
  return http({
    url: '/api/v2.0/entrance/device/getsysUserDevice',
    method: 'get',
    urlType: 'sporePest'
  })
}

export function spRealDataTime(deviceAddrs) {
  return http({
    url: '/api/v2.0/entrance/device/getRealTimeData?deviceAddrs=' + deviceAddrs,
    method: 'get',
    urlType: 'sporePest'
  })
}

export function sporeDeviceInfo(deviceAddrs) {
  return http({
    url: '/api/v2.0/spore/device/getBtchDeviceDO?deviceAddr=' + deviceAddrs,
    method: 'get',
    urlType: 'sporePest'
  })
}

export function sporeAutoMode(deviceAddrs) {
  return http({
    url: '/api/v2.0/spore/device/getSporeAutoMode?deviceAddr=' + deviceAddrs,
    method: 'get',
    urlType: 'sporePest'
  })
}

export function deviceModel(param) {
  return http({
    url: '/api/v2.0/spore/device/deviceMode',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

export function deviceOper(param) {
  return http({
    url: '/api/v2.0/spore/device/deviceOper',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

export function modSporeAutoMode(param) {
  return http({
    url: '/api/v2.0/spore/device/modSporeAutoMode',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

export function sporeDataAndAIByDO(beginTime, endTime, deviceAddr) {
  return http({
    url: '/api/v2.0/spore/deviceData/getSporeDataAndSporeDataAIByDO?beginTime=' + beginTime + '&endTime=' + endTime + '&deviceAddr=' + deviceAddr + '&pages=1&limit=1000',
    method: 'get',
    urlType: 'sporePest'
  })
}





// WEBPACK FOOTER //
// ./src/until/api/SporePest.js